<template>
  <div class="bg-white py-16 md:py-40">
    <ContentContainer>
      <h3 class="font-display text-heading-h1 font-semibold">
        {{ $t('statistics.heading') }}
      </h3>

      <div class="mt-10 md:mt-24 grid grid-cols 1 md:grid-cols-3 gap-y-4 gap-x-6">
        <div class="rounded-[8px] bg-gray-400 text-black hover:bg-black hover:text-white px-8 py-20 text-center group">
          <div class="md:min-h-[101px] font-display text-[44px] md:text-display-s md:group-hover:text-display-m font-semibold transition-all">
            {{ $t('statistics.data1.number') }}
          </div>

          <div class="mt-5 font-body text-body-s">
            {{ $t('statistics.data1.description') }}
          </div>
        </div>
        <div class="rounded-[8px] bg-gray-400 text-black hover:bg-black hover:text-white px-8 py-20 text-center group">
          <div class="md:min-h-[101px] font-display text-[44px] md:text-display-s md:group-hover:text-display-m font-semibold transition-all">
            {{ $t('statistics.data2.number') }}
          </div>

          <div class="mt-5 font-body text-body-s">
            {{ $t('statistics.data2.description') }}
          </div>
        </div>
        <div class="rounded-[8px] bg-gray-400 text-black hover:bg-black hover:text-white px-8 py-20 text-center group">
          <div class="md:min-h-[101px] font-display text-[44px] md:text-display-s md:group-hover:text-display-m font-semibold transition-all">
            {{ $t('statistics.data3.number') }}
          </div>

          <div class="mt-5 font-body text-body-s">
            {{ $t('statistics.data3.description') }}
          </div>
        </div>
      </div>
    </ContentContainer>
  </div>
</template>
<script>
import ContentContainer from "@/components/ui/ContentContainer.vue";

export default {
  components: {
    ContentContainer,
  },
}
</script>
